import { render, staticRenderFns } from "./RecordedUploadFrom.vue?vue&type=template&id=44aa74b5&scoped=true&"
import script from "./RecordedUploadFrom.vue?vue&type=script&lang=ts&"
export * from "./RecordedUploadFrom.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedUploadFrom.vue?vue&type=style&index=0&id=44aa74b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aa74b5",
  null
  
)

export default component.exports